<div class="revo-grid-box  border rounded">
    <revo-grid [source]="source" [columns]="columns" [readonly]="true" [autoSizeColumn]="true" [resize]="true" theme="material"
        rowClass="rowClass"></revo-grid>
</div>